module.exports = __webpack_public_path__ + "media/newstyle/images/book-e2a1d197a44a58f21fdf8bb8915f2259.png";